import { render, staticRenderFns } from "./CoachsOrders.vue?vue&type=template&id=147b03bb"
import script from "./CoachsOrders.vue?vue&type=script&lang=js"
export * from "./CoachsOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports